import { render, staticRenderFns } from "./OtherCharges.vue?vue&type=template&id=16263008&scoped=true"
import script from "./OtherCharges.vue?vue&type=script&lang=js"
export * from "./OtherCharges.vue?vue&type=script&lang=js"
import style0 from "./OtherCharges.vue?vue&type=style&index=0&id=16263008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16263008",
  null
  
)

export default component.exports